import {MoovementApiClient} from "src/app/infrastructure/moovement-api/web-api/moovement.api-client";
import {Observable} from "rxjs";
import {Injectable} from "@angular/core";
import {WaterPoint} from "src/app/infrastructure/moovement-api/models/asset";

@Injectable({
  providedIn: 'root'
})
export class WaterPointApiClient extends MoovementApiClient {

  create(waterPoint: WaterPoint): Observable<WaterPoint> {
    return this.httpClient.put<WaterPoint>(`${this.baseUrl}/api/waterPoint`, waterPoint);
  }

  mergeWaterPoint(waterPoint: WaterPoint): Observable<WaterPoint> {
    return this.httpClient.post<WaterPoint>(`${this.baseUrl}/api/waterPoint`, waterPoint);
  }
}
